import { translate } from "./i18n";
import { displayTagValue } from "./shotTags";
import {
  buildDecoratedShots,
  dateStamp,
  getExportHeaders,
} from "./exportShotlistShared";

function escapeHtml(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function buildShotlistHtmlString({
  decorated,
  baseName = "shotlist",
  y,
  m,
  d,
  lang = "en",
}) {
  const t = (k, vars) => translate(lang, k, vars);
  const headers = getExportHeaders(lang);

  const note =
    String(lang).toLowerCase() === "fr"
      ? 'Ce fichier dépend du dossier <code>images/</code> à côté.'
      : 'This file depends on the <code>images/</code> folder next to it.';

  const htmlRows = (decorated || [])
    .map((r) => {
      const imgHtml = r.imageFilename
        ? `<img alt="" src="images/${escapeHtml(r.imageFilename)}" style="max-width:120px;max-height:70px;object-fit:contain;" />`
        : "";

      return `<tr>
  <td>${escapeHtml(r.sceneLabel ?? r.sceneIdx)}</td>
  <td>${escapeHtml(r.shotNumber)}</td>
  <td>${escapeHtml(r.intExt)}</td>
  <td>${escapeHtml(r.location)}</td>
  <td>${escapeHtml(r.timeOfDay)}</td>
  <td>${escapeHtml(displayTagValue("shotSize", r.shotSize, lang))}</td>
  <td>${escapeHtml(displayTagValue("angle", r.angle, lang))}</td>
  <td>${escapeHtml(r.lensMm)}</td>
  <td>${escapeHtml(displayTagValue("focus", r.focus, lang))}</td>
  <td>${escapeHtml(displayTagValue("framing", r.framing, lang))}</td>
  <td>${escapeHtml(displayTagValue("movement", r.movement, lang))}</td>
  <td>${escapeHtml(r.lights)}</td>
  <td>${escapeHtml(r.durationSec)}</td>
  <td>${escapeHtml(r.description)}</td>
  <td>${escapeHtml(r.ratioLabel)}</td>
  <td>${escapeHtml(r.colorLabel)}</td>
  <td>${imgHtml}</td>
  <td style="white-space:pre-wrap">${escapeHtml(r.scriptText)}</td>
  <td>${r.isMaster ? "MASTER" : ""}</td>
</tr>`;
    })
    .join("\n");

  const title = `${baseName}_shotlist_${y}-${m}-${d}`;

  return `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>${escapeHtml(title)}</title>
  <style>
    body{font-family:Arial,sans-serif;padding:16px;}
    table{border-collapse:collapse;width:100%;}
    th,td{border:1px solid #ccc;padding:6px;vertical-align:top;}
    th{background:#f3f3f3;position:sticky;top:0;}
  </style>
</head>
<body>
  <h1>${escapeHtml(t("export.html.title"))}</h1>
  <p>${note}</p>
  <table>
    <thead><tr>${headers.map((h) => `<th>${escapeHtml(h)}</th>`).join("")}</tr></thead>
    <tbody>
      ${htmlRows}
    </tbody>
  </table>
</body>
</html>`;
}

export function buildShotlistHtml({
  shots,
  scenes,
  scriptText,
  lang = "en",
  baseName = "shotlist",
  shotPrefixMode,
  shotFrameFormat,
}) {
  const { y, m, d } = dateStamp();
  const decorated = buildDecoratedShots({
    shots,
    scenes,
    scriptText,
    lang,
    shotPrefixMode,
    shotFrameFormat,
  });

  const html = buildShotlistHtmlString({ decorated, baseName, y, m, d, lang });
  const filename = `${baseName}_shotlist_${y}-${m}-${d}.html`;
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });

  return { filename, html, blob, decorated };
}
